import React from "react";
import { useTranslation } from "react-i18next";
import { calculateTimeRemaining } from "../utils";

interface TimeRemainingProps {
  endDate: string;
}

export const RemanDaysCell = (value: string) => {
  return <TimeRemaining endDate={value} />;
};

export const TimeRemaining: React.FC<TimeRemainingProps> = ({ endDate }) => {
  const { i18n } = useTranslation(["profile"]);
  const currentLanguage = i18n.language;

  const result = calculateTimeRemaining(endDate, currentLanguage);

  return (
    <div
      style={{
        color: result.isWarning
          ? "rgba(252, 71, 71, 1)"
          : "rgba(43, 54, 116, 1)",
      }}
    >
      {result.text}
    </div>
  );
};
